export enum WsServerEvents {
  TABLE_UPDATED = 'tU',
  SECTOR_UPDATED = 'secU',
  CAJA_UPDATED = 'cjU',
  CUSTOM_FIELDS_UPDATED = 'cfU',
  BRANCH_UPDATED = 'bU',
  RESERVATION_UPDATED = 'rsvU',
  TABLE_BOARD_DIRTY = 'tbD',
  MENU_IMPORT = 'miU',
}
